import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useTable, usePagination, useFlexLayout } from 'react-table';
import { FormattedMessage } from 'react-intl';
import './AlertRequestsTable.css';

const ROW_HEIGHT = 70;

const AlertRequestsTable = (props) => {
  const { 
    headerTitle, 
    columns, 
    data,
    dataCount,
    totalDataCount,
  } = props;
  const [startIndex, setStartIndex] = useState(0);

  const scrollBarWrapperRef = useRef();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    useFlexLayout
  );

  return (
    <div className="alertTableContainer">
      <div className="tableHeader">
        <FormattedMessage id={headerTitle} />
      </div>
      <div className="scrollBarWrapper" ref={scrollBarWrapperRef} style={{ maxHeight: 'calc(100vh - 300px)' }}>
        <table {...getTableProps()} className="alert-requests-table table">
          <thead>
            {headerGroups.map(headerGroup => {
              const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
              return (
                <tr key={key} {...restHeaderGroupProps}>
                  {headerGroup.headers.map(column => {
                    const { key: columnKey, ...restColumnProps } = column.getHeaderProps();
                    return (
                      <th key={columnKey} {...restColumnProps}>
                        {column.render('Header')}
                      </th>
                    );
                  })}
                </tr>
              );
            })}
          </thead>
          <tbody {...getTableBodyProps()}>
            <tr id='top-block' style={{ borderWidth: 0, height: startIndex * ROW_HEIGHT, overflow: 'hidden' }}>
              <td style={{ overflow: 'hidden', borderWidth: 0, padding: 0 }} />
            </tr>
            {rows.map((row, i) => {
              prepareRow(row);
              const { key, ...restRowProps } = row.getRowProps();
              return (
                <tr key={key} {...restRowProps}>
                  {row.cells.map(cell => {
                    const { key: cellKey, ...restCellProps } = cell.getCellProps();
                    return (
                      <td key={cellKey} className="alertRowCell text-break" {...restCellProps}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
            <tr id='bottom-block' style={{ borderWidth: 0, height: (dataCount - data.length - startIndex) * ROW_HEIGHT, overflow: 'hidden' }}>
              <td style={{ overflow: 'hidden', borderWidth: 0, padding: 0 }} />
            </tr>
          </tbody>
        </table>
      </div>
      <div className="tableFooter">
        <FormattedMessage id="CURRENTLY_VIEWING" values={{dataCount: dataCount}} />&nbsp;&nbsp;|&nbsp;&nbsp;
        <FormattedMessage id="TOTAL_COUNT" values={{totalDataCount: totalDataCount}} />&nbsp;&nbsp;
      </div>
    </div>
  );
};

export default AlertRequestsTable;
